import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { eduplayClient } from '@/data/@clients';
import type {
  UseShowLessonVideoResponse,
  UseUpdateLessonProgressPayload,
} from '@/data/eduplay/lessons/interfaces';

export const useShowLessonVideo = (lessonId: string) =>
  useQuery<UseShowLessonVideoResponse>({
    queryKey: ['lessonVideo', lessonId],
    queryFn: async () => await eduplayClient.get(`/aula/${lessonId}/video`),
    enabled: !!lessonId,
  });

export const useUpdateLessonProgress = (lessonId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      progress,
      cursosHorariosId,
    }: UseUpdateLessonProgressPayload) =>
      await eduplayClient.put(`/aula/${lessonId}/progresso`, {
        progress,
        cursosHorariosId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lessons'] });
    },
  });
};
